/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileSmall } from "./_background/background-file-small.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileImageSmall = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--small",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "small" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 40,
      height: 40,
      className: cls,
      "data-testid": "FileImageSmall",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileSmall, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.167 7.167h11.666v6.622l-.218-.218-.043-.043c-.363-.364-.752-.752-1.134-1.062a2.709 2.709 0 0 0-.778-.51 1.933 1.933 0 0 0-.574-.176 2.709 2.709 0 0 0-2.414.745l-1.807 1.808a.64.64 0 0 1-.883 0l-.316-.316a1.873 1.873 0 0 0-1.652-.513 1.358 1.358 0 0 0-.398.119 1.89 1.89 0 0 0-.198.098v.01c-.1.06-.188.126-.264.186a7.438 7.438 0 0 0-.727.689l-.12.127c-.05.051-.096.1-.14.147V7.167Zm4.657 5.349a1.158 1.158 0 0 1-.494.067 1.158 1.158 0 0 1-1.249-1.25 1.161 1.161 0 0 1 1.249-1.25 1.16 1.16 0 0 1 1.25 1.25 1.161 1.161 0 0 1-.756 1.183Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M17.748 14.472c.346.347.718.72 1.085 1.03v3.331H7.167V16.49c.058-.026.108-.055.15-.08.13-.08.252-.18.36-.278.176-.16.37-.363.548-.55a55.996 55.996 0 0 1 .191-.201v.005l.344-.344c.059-.053.115-.102.17-.145a1.017 1.017 0 0 1 .237-.152.627.627 0 0 1 .615.159l.315.316a1.873 1.873 0 0 0 2.65 0l1.808-1.81a1.467 1.467 0 0 1 1.604-.307l.007.003c.11.056.249.145.42.28l.029.022.018.018.942.875v-.002l.173.173Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M18.834 7.167H7.167v.503h11.667v-.503Zm-7.504 5.416a1.16 1.16 0 0 0 1.242-.998c.012.083.014.167.008.251a1.161 1.161 0 0 1-1.25 1.25 1.158 1.158 0 0 1-1.248-1.25 1.157 1.157 0 0 1 .007-.251 1.157 1.157 0 0 0 .748.93c.158.059.326.082.494.068Zm6.418 1.888-.172-.172v.002l-.943-.875-.018-.018-.029-.023a2.71 2.71 0 0 0-.42-.28l-.007-.002a1.463 1.463 0 0 0-1.603.307l-1.809 1.81a1.873 1.873 0 0 1-2.65 0l-.315-.316a.624.624 0 0 0-.615-.159l-.006.003c-.022.01-.095.041-.23.149a3.212 3.212 0 0 0-.17.145l-.344.344v-.005l-.085.088-.107.112c-.178.188-.371.391-.547.551-.108.097-.23.198-.36.278a1.345 1.345 0 0 1-.151.08v.503a1.36 1.36 0 0 0 .15-.08c.13-.08.253-.18.36-.278.177-.16.37-.362.548-.55a39.032 39.032 0 0 1 .192-.201v.005l.344-.343c.058-.054.115-.103.17-.146a.946.946 0 0 1 .23-.148l.006-.004a.623.623 0 0 1 .615.159l.316.316a1.873 1.873 0 0 0 2.65 0l1.808-1.81a1.467 1.467 0 0 1 1.603-.307l.007.003c.11.057.25.146.42.28l.03.022.017.018.943.875v-.002l.172.173c.347.348.719.72 1.086 1.03v-.503c-.367-.31-.739-.683-1.086-1.03Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileImageSmall
};
